import React from 'react';

import {
  BooleanInput,
  required,
  SelectArrayInput,
} from 'react-admin';

import { Box } from '@mui/material';

import ruleNames from '../../../../constants/ruleNames';
import rulesShortDescription from '../../../rules/ruleFeatures/rulesShortDescription';
import SmartDateInput from '../../../../customFields/SmartDateInput';
import isPastDate from '../../../utils/reports/isPastDate';
import dateRangeValidation from '../../../utils/reports/dateRangeValidation';
import FieldBox from '../FieldBox';
import RangeFields from '../RangeFields';

const ruleTypeChoices = [
  ruleNames.CASH_FLOW,
  ruleNames.AMOUNT_THRESHOLD,
  ruleNames.OUTGOING_VOLUME_ROLLING_SUM,
  ruleNames.INCOMING_VOLUME_ROLLING_SUM,
  ruleNames.TOTAL_VOLUME_ROLLING_SUM,
  ruleNames.OUTGOING_FREQUENCY,
  ruleNames.INCOMING_FREQUENCY,
  ruleNames.TOTAL_FREQUENCY,
].map((rule) => ({ id: rule, name: rulesShortDescription[rule] }));

const thresholdFactorChoices = [
  { name: 0.5, id: 0.5 },
  { name: 0.75, id: 0.75 },
  { name: 0.9, id: 0.9 },
  { name: 1.1, id: 1.1 },
  { name: 1.25, id: 1.25 },
  { name: 1.5, id: 1.5 },
];

const RuleThresholdVariation = () => (
  <Box display="flex" flexDirection="column" gap={4}>
    <FieldBox title="Date range" description="Only data within this date range is analysed. Both dates are required.">
      <RangeFields
        from={(
          <SmartDateInput fullWidth validate={[required(), isPastDate, dateRangeValidation]} source="report.from" label="From *" helperText={false} />
        )}
        to={(
          <SmartDateInput fullWidth validate={[required(), dateRangeValidation]} source="report.to" label="To *" helperText={false} />
        )}
      />
    </FieldBox>
    <FieldBox title="Rules" description="Filter to only consider these rules for threshold analysis. Leave empty to include all rules.">
      <SelectArrayInput
        fullWidth
        label=""
        choices={ruleTypeChoices}
        source="report.ruleTypes"
        helperText={false}
      />
    </FieldBox>
    <FieldBox title="Threshold factors *" description="The threshold factors used to estimate how many times each rule would have triggered during the period. Required.">
      <SelectArrayInput
        fullWidth
        label=""
        choices={thresholdFactorChoices}
        source="report.thresholdChangesToBacktest"
        validate={required()}
        helperText={false}
      />
    </FieldBox>
    <FieldBox
      title="One trigger per entity"
      description={
        'If enabled, only one trigger per entity/rule/threshold combination is counted in '
        + 'the total. In other words, if a single entity exceeds the backtest threshold '
        + 'multiple times during the backtest period, it will still only count once towards '
        + 'the total for the rule and backtest level.'
      }
      inline
    >
      <BooleanInput source="report.only1ObsPerEntity" label="" helperText={false} defaultValue={false} />
    </FieldBox>
  </Box>
);

export default RuleThresholdVariation;
